module.exports = __webpack_public_path__ + "static/media/adminportal1.acd0d2f0.svg";